

// import { useQuery } from 'react-query';
// import axios from 'axios';
// import Papa from 'papaparse';
// import React from 'react';


// const fetchCsvData3 = async () => {
//   try {
//     const response = await axios.get('/assets/CSVs/product_options.csv');
//     // const baseUrl = process.env.PUBLIC_URL;
//     // const response = await axios.get(`${baseUrl}/assets/CSVs/product_options.csv`);

//     // const response = await axios.get('https://cors-anywhere.herokuapp.com/https://platinumcctv.com/assets/CSVs/products_options.csv');
//     // const response = await axios.get('https://test.cors.workers.dev/https://platinumcctv.com/assets/CSVs/product_options.csv');
//     // const response = await axios({
//     //   method: 'get',
//     //   url: 'https://cors-anywhere.herokuapp.com/https://platinumcctv.com/assets/CSVs/product_options.csv',
//     //   headers: {'Origin': 'http://quotes.platinumcctv.net/'}
//     // })

//     const { data } = response;
//     const parsedData = Papa.parse(data, { header: true }).data;
//     return parsedData;
//   } catch (error) {
//     throw new Error('Failed to fetch and parse CSV data');
//   }
// };

// export function ProductOptionsCsvData() {
//   const [productOptionCSVQuery, setProductOptionCSVQuery] = React.useState([]);
//   const { data, isLoading3, isError3, error3 } = useQuery('ProductOptionsCsvData', fetchCsvData3);
//   React.useEffect(() => {
//     if (!isLoading3 && !isError3) {
//       // Ensure the data is not loading and there are no errors
//       setProductOptionCSVQuery(data);
//     }
//   }, [data, isLoading3, isError3]);

//   return { productOptionCSVQuery, isLoading3, isError3, error3 };
// }




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Papa from 'papaparse';

const fetchCsvData3 = async () => {
  try {
    const response = await axios.get('/assets/CSVs/product_options.csv');
    const { data } = response;
    const parsedData = Papa.parse(data, { header: true }).data;
    return parsedData;
  } catch (error) {
    throw new Error('Failed to fetch and parse CSV data');
  }
};

export function ProductOptionsCsvData() {
  const [productOptionCSVQuery, setProductOptionCSVQuery] = useState([]);
  const [isLoading3, setIsLoading3] = useState(true);
  const [isError3, setIsError3] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading3(true);
      setIsError3(null);
      try {
        const data = await fetchCsvData3();
        setProductOptionCSVQuery(data);
      } catch (error) {
        setIsError3(error);
      } finally {
        setIsLoading3(false);
      }
    };

    loadData();
  }, []); // Empty dependency array means this useEffect runs once on mount

  return { productOptionCSVQuery, isLoading3, isError3 };
}
